var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeIcon = function SvgYoutubeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m9.25 6.647 9.165 5.728-9.165 5.728V6.647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.585 24.25c3.688 0 6.665-2.853 6.665-6.356V7.105c0-3.502-2.977-6.355-6.665-6.355H7.415C3.727.75.75 3.603.75 7.105v10.789c0 3.503 2.977 6.356 6.665 6.356h10.17z"
  }))));
};
export { SvgYoutubeIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI1IDI1IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjRkZGIiBzdHJva2Utd2lkdGg9IjEuNSI+CiAgICAgICAgPHBhdGggc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTkuMjUgNi42NDdsOS4xNjUgNS43MjgtOS4xNjUgNS43MjhWNi42NDd6Ii8+CiAgICAgICAgPHBhdGggZD0iTTE3LjU4NSAyNC4yNWMzLjY4OCAwIDYuNjY1LTIuODUzIDYuNjY1LTYuMzU2VjcuMTA1YzAtMy41MDItMi45NzctNi4zNTUtNi42NjUtNi4zNTVINy40MTVDMy43MjcuNzUuNzUgMy42MDMuNzUgNy4xMDV2MTAuNzg5YzAgMy41MDMgMi45NzcgNi4zNTYgNi42NjUgNi4zNTZoMTAuMTd6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";